import { createFileRoute } from '@tanstack/react-router'

import { AddFundPage } from '@/components/AddFundPage'

export const Route = createFileRoute('/_app/funds/add')({
  component: AddFundPageRoute,
})

function AddFundPageRoute() {
  return <AddFundPage />
}
